/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Widget from 'components/Widget/index';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import { chartColors } from 'util/chartUtils';
import WidgetRainbow from '../../common/WidgetRainbow';
import IntlMessages from "../../../../../util/IntlMessages";
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const AffectedUsers = ({ queryNoResult }) => {
  const t = useLocalizedMessage();
  const { isFetching, users, error } = queryNoResult;

  if (isFetching) {
    return (
      <Widget styleName="jr-card-full noMargin">
        <PlaceholderSpinner height={129} />
      </Widget>
    );
  }

  const pieData = [
    { id: '1', name: t('analytics.affectedUsers.title'), fill: chartColors.main.normal, value: users ? users.filteredTotal : '-' },
    { id: '2', name: t('analytics.otherUsers.title'), fill: chartColors.main.light, value: users ? users.otherTotal : '-' },
  ];
  const mainNumber = error || !(users && users.filteredTotal)
    ? '-'
    : users.filteredTotal;

  return (
    <WidgetRainbow
      pieData={pieData}
      title={<IntlMessages id="analytics.affectedUsers.title" />}
      mainNumber={mainNumber}
      description={<IntlMessages id="analytics.affectedUsers.description" />}
      tone="zeroResults"
    />
  );
};

export default AffectedUsers;
